<!--
~ Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
-->

<ngf-dialog-title mat-dialog-title>
  {{ data.title }}
</ngf-dialog-title>

<mat-dialog-content>
  <div class="modal-message">
    @if (!data.messageAsHtml) {
      <span>{{data.message}}</span>
    }
    @if (data.messageAsHtml) {
      <span [innerHTML]="data.message"></span>
    }
  </div>
  @if (data.warning) {
    <ngf-message-warning>
      @if (!data.warningAsHtml) {
        <span>{{data.warning}}</span>
      } @else {
        <span [innerHTML]="data.warning"></span>
      }
    </ngf-message-warning>
  }
</mat-dialog-content>

<mat-dialog-actions>
  <button ngfButton
    [attr.size]="data.smallButton ? 'small' : null"
    (click)="cancel()">
    {{data.cancelLabel || 'Cancel'}}
  </button>
  <button ngfButton="primary"
    [attr.size]="data.smallButton ? 'small' : null"
    (click)="confirm()">
    {{data.confirmLabel || 'Confirm'}}
  </button>
</mat-dialog-actions>
